/**
 * Replace all characters except numbers
 *
 * @param {string|number} value
 * @returns {string}
 */
export const parseDigits = value => value.replace(/\D/gm, '')
